/**
 * The name of the route currently on screen, kept for analytics.
 *
 * Deliberately a plain module rather than a read of the router: the analytics
 * service is called from stores as well as components, and importing the router
 * there would close a cycle (`routes` imports the navigation guard, which
 * imports the analytics service). The guard pushes the name in instead.
 *
 * Route *name* rather than path, because names are stable and already grouped
 * the way a report wants to read them, where a path carries ids and query
 * strings that have to be stripped back off.
 */

let currentRouteName: string = '';

/** Record the route now on screen. Called from the router's navigation guard. */
export function setCurrentRouteName(name: unknown): void {
   currentRouteName = typeof name === 'string' ? name : '';
}

/** The route now on screen, or `''` before the first navigation settles. */
export function getCurrentRouteName(): string {
   return currentRouteName;
}
